const CompanySelector = ({
  companyList,
  selectedCompany,
  onCompanyChange,
  containerClassName = "",
  selectClassName = "",
}) => {
  return (
    <div
      className={` flex justify-center items-center p-[10px] border border-[#cacaca] text-[var(--secondary-color)] rounded text-[12px] ${containerClassName}`}
    >
      <i className="ri-home-4-fill"></i>

      <select
        className={`w-60 border-none text-[var(--secondary-color)] bg-[var(--primary-color)] outline-none ${selectClassName}`}
        value={selectedCompany?.name || ""}
        onChange={(e) => {
          if (!e.target.value) {
            onCompanyChange(null);
            return;
          }

          const company = companyList.find(
            (item) => item.company_name === e.target.value,
          );

          if (company) {
            onCompanyChange(company);
          }
        }}
      >
        <option value="">All Companies</option>

        {companyList?.map((company) => (
          <option key={company.id} value={company.company_name}>
            {company.company_name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default CompanySelector;
